var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e(),_c('ewm',{ref:"ewm"}),_c('AI')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }